import { render, staticRenderFns } from "./MonthPayerGroups.vue?vue&type=template&id=4c1b9d3e&scoped=true&"
import script from "./MonthPayerGroups.vue?vue&type=script&lang=js&"
export * from "./MonthPayerGroups.vue?vue&type=script&lang=js&"
import style0 from "./MonthPayerGroups.vue?vue&type=style&index=0&id=4c1b9d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b9d3e",
  null
  
)

export default component.exports